import { Component, Input, Output } from '@angular/core';
import { AppState } from '../../../../app.service';
import { ReplicatedService } from './replicated.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { constructInnerTableRestorePoints } from '../../dataprotection-common/common-renderers';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { Modal, State } from '@clr/angular';
import { StorageComparator } from '../../dataprotection-common/comparator';
var $ = require('jquery');

@Component({
  selector: 'replicated-vapp-vm',
  providers: [
    ReplicatedService, TranslateService
  ],
  styles: [require('./replicated-vdc.scss')],
  template: require('./replicated-vapp-vm.html')
})

export class ReplicatedVappVm {
  @Input() isVisible: boolean;
  @Input() mode: string;
  @Input() selectedEntity: any = null;
  private loading: boolean = false;
  private replicatedVappVms: any;
  private pageSize: number = 5;

  private subscribeHandler;

  constructor(public appState: AppState, public service: ReplicatedService, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  //Life Cycle Hooks
  ngOnInit() {
    this.getReplicatedVappVms();
  }

  ngOnChanges(changes) {
    if ( changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue ) {
      this.getReplicatedVappVms();
    }
  }

  refresh(state: State) {
    this.loading = true;
    this.getReplicatedVappVms();
  }

  ngAfterViewInit() {
    // todo
  }

  ngOnDestroy() {
    if(this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  getReplicatedVappVms() {
      this.replicatedVappVms = this.selectedEntity && this.selectedEntity.vms ? this.selectedEntity.vms : [];
      this.loading = false;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated-vapp-vm.component.ts